/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScoreAnswer
 */
export interface ScoreAnswer {
    /**
     * 
     * @type {number}
     * @memberof ScoreAnswer
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ScoreAnswer
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreAnswer
     */
    correctAnswer: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreAnswer
     */
    givenAnswer: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScoreAnswer
     */
    isCorrect: boolean | null;
}

/**
 * Check if a given object implements the ScoreAnswer interface.
 */
export function instanceOfScoreAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "question" in value;
    isInstance = isInstance && "correctAnswer" in value;
    isInstance = isInstance && "givenAnswer" in value;
    isInstance = isInstance && "isCorrect" in value;

    return isInstance;
}

export function ScoreAnswerFromJSON(json: any): ScoreAnswer {
    return ScoreAnswerFromJSONTyped(json, false);
}

export function ScoreAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoreAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'question': json['question'],
        'correctAnswer': json['correct_answer'],
        'givenAnswer': json['given_answer'],
        'isCorrect': json['is_correct'],
    };
}

export function ScoreAnswerToJSON(value?: ScoreAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'question': value.question,
        'correct_answer': value.correctAnswer,
        'given_answer': value.givenAnswer,
        'is_correct': value.isCorrect,
    };
}

